"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEpgNow = void 0;
var react_1 = require("react");
var useRouteFocused_1 = require("stremio/common/useRouteFocused");
var constants_1 = require("./constants");
var createClock = function (intervalMs) {
    var now = Date.now();
    var timer = null;
    var listeners = new Set();
    var update = function () {
        now = Date.now();
        listeners.forEach(function (listener) { return listener(); });
    };
    var onVisibilityChange = function () {
        if (timer !== null)
            window.clearInterval(timer);
        timer = null;
        if (!document.hidden) {
            update();
            timer = window.setInterval(update, intervalMs);
        }
    };
    return {
        getSnapshot: function () { return now; },
        subscribe: function (listener) {
            listeners.add(listener);
            if (listeners.size === 1) {
                document.addEventListener('visibilitychange', onVisibilityChange);
                onVisibilityChange();
            }
            return function () {
                listeners.delete(listener);
                if (listeners.size === 0) {
                    if (timer !== null)
                        window.clearInterval(timer);
                    timer = null;
                    document.removeEventListener('visibilitychange', onVisibilityChange);
                }
            };
        },
    };
};
var clocks = new Map();
var unsubscribe = function () { return undefined; };
var useEpgNow = function (enabled, intervalMs) {
    var _a;
    if (intervalMs === void 0) { intervalMs = constants_1.EPG_NOW_REFRESH_INTERVAL; }
    var active = (0, useRouteFocused_1.useRouteActive)();
    var clock = (_a = clocks.get(intervalMs)) !== null && _a !== void 0 ? _a : createClock(intervalMs);
    if (!clocks.has(intervalMs))
        clocks.set(intervalMs, clock);
    var subscribe = (0, react_1.useCallback)(function (listener) { return enabled && active ? clock.subscribe(listener) : unsubscribe; }, [enabled, active, clock]);
    return (0, react_1.useSyncExternalStore)(subscribe, clock.getSnapshot);
};
exports.useEpgNow = useEpgNow;
